import AuthService from './AuthService.js';

// Données mockées pour le développement frontend
const MOCK_DATA = {
  youngUsers: [
    {
      id: 1,
      username: 'alex_martin',
      firstName: 'Alex',
      lastName: 'Martin',
      age: 16,
      profilePicture: null,
      relationshipType: 'parent',
      dateCreated: '2024-01-15',
      lastActivity: '2025-10-15',
      gamesCompletion: 78,
      observationsCount: 12,
      badgesCount: 8,
      otherAccompanists: [
        { id: 102, name: 'Pierre Dubois', type: 'educateur' }
      ]
    },
    {
      id: 2,
      username: 'marie_dupont',
      firstName: 'Marie',
      lastName: 'Dupont',
      age: 18,
      profilePicture: null,
      relationshipType: 'educateur',
      dateCreated: '2024-03-20',
      lastActivity: '2025-10-14',
      gamesCompletion: 92,
      observationsCount: 18,
      badgesCount: 12,
      otherAccompanists: [
        { id: 201, name: 'Claire Dupont', type: 'parent' },
        { id: 202, name: 'Dr. Martin', type: 'therapeute' }
      ]
    },
    {
      id: 3,
      username: 'lucas_bernard',
      firstName: 'Lucas',
      lastName: 'Bernard',
      age: 15,
      profilePicture: null,
      relationshipType: 'parent',
      dateCreated: '2024-06-10',
      lastActivity: '2025-10-13',
      gamesCompletion: 45,
      observationsCount: 5,
      badgesCount: 3,
      otherAccompanists: []
    }
  ],

  competenceBlocks: [
    {
      id: 1,
      name: 'Communication & Expression',
      description: 'Capacité à s\'exprimer et échanger efficacement',
      icon: '🗣️',
      color: '#3B82F6',
      order: 1,
      competences: [
        { key: 'assertivite', name: 'Assertivité', description: 'Capacité à exprimer ses idées clairement' },
        { key: 'communication', name: 'Communication', description: 'Capacité à transmettre des informations' },
        { key: 'diplomatie', name: 'Diplomatie', description: 'Habileté à gérer des situations délicates' },
        { key: 'ecouteActive', name: 'Écoute active', description: 'Capacité à être attentif aux autres' },
        { key: 'negociation', name: 'Négociation', description: 'Capacité à trouver des compromis' }
      ]
    },
    {
      id: 2,
      name: 'Relations & Empathie',
      description: 'Capacité à comprendre et interagir avec les autres',
      icon: '💚',
      color: '#10B981',
      order: 2,
      competences: [
        { key: 'empathie', name: 'Empathie', description: 'Comprendre les sentiments des autres' },
        { key: 'espritEquipe', name: 'Esprit d\'équipe', description: 'Travailler efficacement en groupe' },
        { key: 'soutien', name: 'Soutien', description: 'Encourager et aider les autres' },
        { key: 'mediation', name: 'Médiation', description: 'Résoudre des conflits' },
        { key: 'inclusion', name: 'Inclusion', description: 'Valoriser la diversité' }
      ]
    },
    {
      id: 3,
      name: 'Flexibilité & Adaptation',
      description: 'Capacité à s\'adapter aux changements et situations nouvelles',
      icon: '🌟',
      color: '#F59E0B',
      order: 3,
      competences: [
        { key: 'adaptabilite', name: 'Adaptabilité', description: 'S\'ajuster aux changements' },
        { key: 'initiative', name: 'Initiative', description: 'Agir spontanément' },
        { key: 'reflexionRapide', name: 'Réflexion rapide', description: 'Décisions sous pression' },
        { key: 'gestionStress', name: 'Gestion du stress', description: 'Rester calme en tension' },
        { key: 'creativite', name: 'Créativité', description: 'Trouver des solutions originales' }
      ]
    },
    {
      id: 4,
      name: 'Autonomie & Confiance',
      description: 'Capacité à agir de manière indépendante et assurée',
      icon: '💪',
      color: '#8B5CF6',
      order: 4,
      competences: [
        { key: 'confianceEnSoi', name: 'Confiance en soi', description: 'Assurance dans ses capacités' },
        { key: 'autonomie', name: 'Autonomie', description: 'Travailler par soi-même' },
        { key: 'responsabilite', name: 'Responsabilité', description: 'Assumer ses actes' },
        { key: 'decision', name: 'Prise de décision', description: 'Faire des choix éclairés' },
        { key: 'patience', name: 'Patience', description: 'Accepter les délais' }
      ]
    }
  ],

  youngProfile: {
    1: {
      user: {
        id: 1,
        username: 'alex_martin',
        firstName: 'Alex',
        lastName: 'Martin',
        age: 16
      },
      accompanists: [
        { id: 101, name: 'Sophie Martin', type: 'parent', since: '2024-01-15' },
        { id: 102, name: 'Pierre Dubois', type: 'educateur', since: '2024-02-20' }
      ],
      gamesData: {
        scenario: { completion: 0.75, currentLevel: 6, traits: { empathie: 15, diplomatie: 12, assertivite: 10, pragmatisme: 14 } },
        shapeSequence: { completion: 0.80, currentLevel: 8 },
        jobs: { completion: 1.0, jobChoices: { preferred: ['Informatique', 'Design'] } },
        speed: { completion: 0.65, currentLevel: 5 },
        skills: { completion: 1.0 },
        roomEnv: { completion: 0.90 }
      },
      competenceValidations: [
        {
          blockId: 1,
          blockName: 'Communication & Expression',
          competences: [
            { key: 'assertivite', name: 'Assertivité', stars: 4, validated: false, observationsCount: 4, gameScore: 10 },
            { key: 'communication', name: 'Communication', stars: 5, validated: true, observationsCount: 6, gameScore: 15 },
            { key: 'diplomatie', name: 'Diplomatie', stars: 3, validated: false, observationsCount: 3, gameScore: 12 }
          ]
        },
        {
          blockId: 2,
          blockName: 'Relations & Empathie',
          competences: [
            { key: 'empathie', name: 'Empathie', stars: 5, validated: true, observationsCount: 7, gameScore: 15 },
            { key: 'espritEquipe', name: 'Esprit d\'équipe', stars: 4, validated: false, observationsCount: 4, gameScore: 11 },
            { key: 'soutien', name: 'Soutien', stars: 3, validated: false, observationsCount: 3, gameScore: 8 }
          ]
        },
        {
          blockId: 3,
          blockName: 'Flexibilité & Adaptation',
          competences: [
            { key: 'adaptabilite', name: 'Adaptabilité', stars: 4, validated: false, observationsCount: 5, gameScore: 13 },
            { key: 'initiative', name: 'Initiative', stars: 2, validated: false, observationsCount: 2, gameScore: 7 },
            { key: 'creativite', name: 'Créativité', stars: 3, validated: false, observationsCount: 3, gameScore: 10 }
          ]
        },
        {
          blockId: 4,
          blockName: 'Autonomie & Confiance',
          competences: [
            { key: 'confianceEnSoi', name: 'Confiance en soi', stars: 5, validated: true, observationsCount: 6, gameScore: 14 },
            { key: 'autonomie', name: 'Autonomie', stars: 4, validated: false, observationsCount: 4, gameScore: 12 },
            { key: 'responsabilite', name: 'Responsabilité', stars: 3, validated: false, observationsCount: 3, gameScore: 9 }
          ]
        }
      ],
      recentObservations: [
        {
          id: 1,
          date: '2025-10-15',
          type: 'ciblée',
          competence: 'Empathie',
          situation: 'Alex a remarqué qu\'un camarade était triste et est allé lui parler spontanément.',
          environment: 'École',
          emotionalState: 'Calme',
          peoplePresent: ['Camarades', 'Professeur'],
          observedBy: 'Pierre Dubois'
        },
        {
          id: 2,
          date: '2025-10-12',
          type: 'libre',
          competence: 'Adaptabilité',
          situation: 'Lors d\'un changement de programme, Alex s\'est rapidement adapté sans montrer de frustration.',
          environment: 'Maison',
          emotionalState: 'Joyeux',
          peoplePresent: ['Parents', 'Fratrie'],
          observedBy: 'Sophie Martin'
        },
        {
          id: 3,
          date: '2025-10-10',
          type: 'ciblée',
          competence: 'Communication',
          situation: 'Alex a expliqué clairement son point de vue lors d\'une discussion familiale.',
          environment: 'Maison',
          emotionalState: 'Concentré',
          peoplePresent: ['Parents'],
          observedBy: 'Sophie Martin'
        }
      ]
    }
  }
};

// Stockage temporaire des observations en session (pour le développement)
const sessionObservations = {};

class AccompanimentService {
  constructor() {
    this.useMockData = false; // Garder les exemples de jeunes en dur
  }

  // Liste des jeunes accompagnés
  async getYoungUsers() {
    if (this.useMockData) {
      return Promise.resolve({ data: MOCK_DATA.youngUsers });
    }

    // Récupérer les connexions depuis le backend
    const response = await AuthService.request('get', '/connections/my-connections');

    // Récupérer toutes les observations créées par l'observateur pour compter
    let observationCounts = {};
    try {
      const obsResponse = await AuthService.request('get', '/observations/created?limit=1000');
      if (obsResponse.data && obsResponse.data.observations) {
        obsResponse.data.observations.forEach(obs => {
          const youngId = obs.observee_id;
          observationCounts[youngId] = (observationCounts[youngId] || 0) + 1;
        });
      }
    } catch (error) {
      console.warn('Could not fetch observations to count them:', error);
    }

    // Transformer les données du backend vers le format attendu par le frontend
    const youngUsers = await Promise.all(
      response.data.map(async (connection) => {
        let gamesCompletion = 0;
        let badgesCount = 0;
        let profilePicture = null;
        let hasProfilePicture = false;

        // Calculer la progression moyenne des jeux et le nombre de badges si la connexion est active
        if (connection.is_active) {
          try {
            const profileResponse = await AuthService.request(
              'get',
              `/observe/young-person/${connection.young_person.user_id}`
            );

            hasProfilePicture = profileResponse.data.profile.has_profile_picture;

            // Transformer les données de jeux pour avoir tous les jeux (même à 0%)
            const allGamesData = this._transformGameProgress(profileResponse.data.game_progress);
            const allGamesList = Object.values(allGamesData);

            if (allGamesList.length > 0) {
              // Calculer la progression sur TOUS les jeux (7 jeux au total)
              gamesCompletion = Math.round(
                (allGamesList.reduce((sum, game) => sum + game.completion, 0) / allGamesList.length) * 100
              );

              // Compter le nombre de badges (jeux complétés à 100%)
              badgesCount = allGamesList.filter(game => game.completion >= 1.0).length;
            }

            // Charger la photo de profil si disponible
            if (hasProfilePicture) {
              try {
                const pictureResponse = await this.getYoungProfilePicture(connection.young_person.user_id);
                profilePicture = pictureResponse.data;
              } catch (error) {
                console.warn(`Could not fetch profile picture for user ${connection.young_person.user_id}:`, error);
              }
            }
          } catch (error) {
            console.warn(`Could not fetch game data for user ${connection.young_person.user_id}:`, error);
          }
        }

        const youngId = connection.young_person.user_id;
        return {
          id: youngId,
          username: connection.young_person.username || 'N/A',
          firstName: connection.young_person.first_name || 'Prénom',
          lastName: connection.young_person.last_name || 'Nom',
          age: connection.young_person.age || null,
          profilePicture: profilePicture,
          relationshipType: 'accompagnateur',
          dateCreated: connection.young_person.date_created,
          lastActivity: connection.date_connected,
          gamesCompletion: gamesCompletion,
          observationsCount: observationCounts[youngId] || 0,
          badgesCount: badgesCount,
          otherAccompanists: [],
          attachmentCode: connection.young_person.attachment_code,
          connectionId: connection.connection_id,
          isActive: connection.is_active
        };
      })
    );

    return { data: youngUsers };
  }

  // Profil détaillé d'un jeune
  async getYoungProfile(youngId) {
    if (this.useMockData) {
      return Promise.resolve({ data: MOCK_DATA.youngProfile[youngId] || null });
    }

    // Appel à la vraie API
    const response = await AuthService.request('get', `/observe/young-person/${youngId}`);
    const apiData = response.data;

    // Transformer les données de l'API vers le format attendu par le frontend
    const transformedData = {
      user: {
        id: apiData.profile.user_id,
        username: apiData.profile.username,
        firstName: apiData.profile.first_name || 'Prénom',
        lastName: apiData.profile.last_name || 'Nom',
        age: apiData.profile.age,
        hasProfilePicture: apiData.profile.has_profile_picture,
        onboardingComplete: apiData.profile.onboarding_complete
      },
      accompanists: [], // À récupérer depuis une autre API si disponible
      attachmentCode: apiData.attachment_code,
      connectionNotes: apiData.connection_notes,
      passions: apiData.passions || [],
      gamesData: this._transformGameProgress(apiData.game_progress),
      competenceValidations: [] // À récupérer depuis une autre API si disponible
    };

    return { data: transformedData };
  }

  // Fonction helper pour transformer les données de progression de jeux
  _transformGameProgress(gameProgressArray) {
    const gameNameMapping = {
      'Scenario Game': 'scenario',
      'Shape Sequence Game': 'shapeSequence',
      'Jobs Game': 'jobs',
      'Speed Game': 'speed',
      'Skills Game': 'skills',
      'Room Environment Game': 'roomEnv'
    };

    // Initialiser tous les jeux à 0%
    const gamesData = {
      scenario: { completion: 0, currentLevel: 0 },
      shapeSequence: { completion: 0, currentLevel: 0 },
      jobs: { completion: 0, currentLevel: 0 },
      speed: { completion: 0, currentLevel: 0 },
      skills: { completion: 0, currentLevel: 0 },
      roomEnv: { completion: 0, currentLevel: 0 }
    };

    // Mettre à jour avec les données réelles du backend
    if (gameProgressArray && Array.isArray(gameProgressArray)) {
      gameProgressArray.forEach(game => {
        const gameKey = gameNameMapping[game.game_name];
        if (gameKey) {
          gamesData[gameKey] = {
            completion: game.completion || 0,
            currentLevel: game.current_level || 0
          };
        }
      });
    }

    return gamesData;
  }

  // Blocs de compétences
  async getCompetenceBlocks() {
    if (this.useMockData) {
      return Promise.resolve({ data: MOCK_DATA.competenceBlocks });
    }
    return AuthService.request('get', '/api/accompaniment/competence-blocks');
  }

  // Données des jeux d'un jeune
  async getYoungGamesData(youngId) {
    if (this.useMockData) {
      const profile = MOCK_DATA.youngProfile[youngId];
      return Promise.resolve({ data: profile?.gamesData || {} });
    }

    // Utiliser la même API que getYoungProfile et extraire uniquement les données de jeux
    const response = await AuthService.request('get', `/observe/young-person/${youngId}`);
    const gamesData = this._transformGameProgress(response.data.game_progress);
    return { data: gamesData };
  }

  // Validations de compétences
  async getYoungValidations(youngId) {
    if (this.useMockData) {
      const profile = MOCK_DATA.youngProfile[youngId];
      return Promise.resolve({ data: profile?.competenceValidations || [] });
    }
    return AuthService.request('get', `/api/accompaniment/young/${youngId}/validations`);
  }

  // Observations récentes
  async getRecentObservations(youngId, limit = 10) {
    if (this.useMockData) {
      const profile = MOCK_DATA.youngProfile[youngId];
      const observations = profile?.recentObservations || [];
      return Promise.resolve({ 
        data: observations.slice(0, limit),
        totalCount: observations.length
      });
    }

    // Appel API - récupérer les observations créées par l'observateur
    // Nous devons récupérer toutes les observations et filtrer côté frontend
    const response = await AuthService.request(
      'get',
      `/observations/created?limit=1000`  // Récupérer un grand nombre pour être sûr d'avoir tout
    );

    // Transformer et filtrer les observations du backend vers le format frontend
    const allMatchingObservations = response.data.observations
      .filter(obs => obs.observee_id === parseInt(youngId, 10));
    
    const totalCount = allMatchingObservations.length;
    
    const observations = allMatchingObservations
      .slice(0, limit)
      .map(obs => {
        const content = obs.content || {};
        const competences = content.competences || [];
        const location = content.location || {};
        const youngBefore = content.youngBefore || {};

        return {
          id: obs.id,  // Backend returns 'id', not 'observation_id'
          date: obs.date_created ? obs.date_created.split('T')[0] : new Date().toISOString().split('T')[0],
          type: competences.length > 0 ? 'ciblée' : 'libre',
          competence: competences.length > 0 ? competences[0] : null,
          competences: competences,
          competenceRatings: content.competenceRatings || {},
          situation: content.factualDescription || '',
          environment: location.description || 'Non spécifié',
          emotionalState: youngBefore.emotionalState || 'Non spécifié',
          peoplePresent: content.peoplePresent || [],
          observedBy: obs.observer?.first_name && obs.observer?.last_name
            ? `${obs.observer.first_name} ${obs.observer.last_name}`
            : obs.observer?.username || 'Vous',
          fullData: content
        };
      });

    return { data: observations, totalCount: totalCount };
  }

  // Créer une observation
  async createObservation(observationData) {
    if (this.useMockData) {
      // Mode mock pour le développement
      await new Promise(resolve => setTimeout(resolve, 800));

      const competences = observationData.competences || [];
      const location = observationData.location || {};
      const youngBefore = observationData.youngBefore || {};
      const peoplePresent = observationData.peoplePresent || [];

      const newObservation = {
        id: Date.now(),
        date: observationData.date,
        type: competences.length > 0 ? 'ciblée' : 'libre',
        competence: competences.length > 0 ? competences[0] : null,
        competences: competences,
        competenceRatings: observationData.competenceRatings || {},
        situation: observationData.factualDescription || '',
        environment: location.description || 'Non spécifié',
        emotionalState: youngBefore.emotionalState || 'Non spécifié',
        peoplePresent: peoplePresent,
        observedBy: 'Vous',
        fullData: observationData
      };

      const youngId = observationData.youngPersonId;
      if (!sessionObservations[youngId]) {
        sessionObservations[youngId] = [];
      }
      sessionObservations[youngId].unshift(newObservation);

      if (MOCK_DATA.youngProfile[youngId]) {
        if (!MOCK_DATA.youngProfile[youngId].recentObservations) {
          MOCK_DATA.youngProfile[youngId].recentObservations = [];
        }
        MOCK_DATA.youngProfile[youngId].recentObservations.unshift(newObservation);
      }

      return Promise.resolve({
        data: {
          success: true,
          observation: newObservation
        }
      });
    }

    // Appel API réel
    const response = await AuthService.request('post', '/observations/', {
      observee_id: observationData.youngPersonId,
      content: observationData
    });

    // Transformer la réponse du backend pour le frontend
    const competences = observationData.competences || [];
    const location = observationData.location || {};
    const youngBefore = observationData.youngBefore || {};
    const peoplePresent = observationData.peoplePresent || [];

    const transformedObservation = {
      id: response.data.id,  // Backend returns 'id', not 'observation_id'
      date: observationData.date,
      type: competences.length > 0 ? 'ciblée' : 'libre',
      competence: competences.length > 0 ? competences[0] : null,
      competences: competences,
      competenceRatings: observationData.competenceRatings || {},
      situation: observationData.factualDescription || '',
      environment: location.description || 'Non spécifié',
      emotionalState: youngBefore.emotionalState || 'Non spécifié',
      peoplePresent: peoplePresent,
      observedBy: response.data.observer?.first_name && response.data.observer?.last_name
        ? `${response.data.observer.first_name} ${response.data.observer.last_name}`
        : response.data.observer?.username || 'Vous',
      fullData: observationData
    };

    return {
      data: {
        success: true,
        observation: transformedObservation
      }
    };
  }

  // Mettre à jour une observation
  async updateObservation(observationId, observationData) {
    if (this.useMockData) {
      // Simuler un délai réseau
      await new Promise(resolve => setTimeout(resolve, 800));

      // Mettre à jour dans sessionObservations
      for (const youngId in sessionObservations) {
        const observations = sessionObservations[youngId];
        const index = observations.findIndex(obs => obs.id === observationId);
        if (index !== -1) {
          // Mettre à jour l'observation tout en gardant l'ID et certaines métadonnées
          const competences = observationData.competences || [];
          const location = observationData.location || {};
          const youngBefore = observationData.youngBefore || {};
          const peoplePresent = observationData.peoplePresent || [];

          const updatedObservation = {
            ...observations[index],
            date: observationData.date,
            type: competences.length > 0 ? 'ciblée' : 'libre',
            competence: competences.length > 0 ? competences[0] : null,
            competences: competences,
            competenceRatings: observationData.competenceRatings || {},
            situation: observationData.factualDescription || '',
            environment: location.description || 'Non spécifié',
            emotionalState: youngBefore.emotionalState || 'Non spécifié',
            peoplePresent: peoplePresent,
            fullData: observationData
          };

          observations[index] = updatedObservation;

          // Mettre à jour aussi dans MOCK_DATA si présent
          if (MOCK_DATA.youngProfile[youngId]) {
            const mockIndex = MOCK_DATA.youngProfile[youngId].recentObservations?.findIndex(
              obs => obs.id === observationId
            );
            if (mockIndex !== -1) {
              MOCK_DATA.youngProfile[youngId].recentObservations[mockIndex] = updatedObservation;
            }
          }

          return Promise.resolve({
            data: {
              success: true,
              observation: updatedObservation
            }
          });
        }
      }

      return Promise.reject({ response: { status: 404, data: { detail: 'Observation not found' } } });
    }

    // Appel API réel
    return AuthService.request('put', `/observations/${observationId}`, {
      content: observationData
    });
  }

  // Supprimer une observation
  async deleteObservation(observationId) {
    if (this.useMockData) {
      // Simuler un délai réseau
      await new Promise(resolve => setTimeout(resolve, 600));

      // Supprimer de sessionObservations
      for (const youngId in sessionObservations) {
        const observations = sessionObservations[youngId];
        const index = observations.findIndex(obs => obs.id === observationId);
        if (index !== -1) {
          observations.splice(index, 1);

          // Supprimer aussi de MOCK_DATA si présent
          if (MOCK_DATA.youngProfile[youngId]) {
            const mockIndex = MOCK_DATA.youngProfile[youngId].recentObservations?.findIndex(
              obs => obs.id === observationId
            );
            if (mockIndex !== -1) {
              MOCK_DATA.youngProfile[youngId].recentObservations.splice(mockIndex, 1);
            }
          }

          return Promise.resolve({
            data: {
              success: true,
              message: 'Observation supprimée avec succès'
            }
          });
        }
      }

      return Promise.reject({ response: { status: 404, data: { detail: 'Observation not found' } } });
    }

    // Appel API réel
    return AuthService.request('delete', `/observations/${observationId}`);
  }

  // Créer une relation accompagnant-jeune
  async createRelation(youngUserId, relationType) {
    if (this.useMockData) {
      return Promise.resolve({ data: { success: true } });
    }
    return AuthService.request('post', '/api/accompaniment/relation', {
      young_user_id: youngUserId,
      relation_type: relationType
    });
  }

  // Valider une compétence
  async validateCompetence(youngId, competenceKey) {
    if (this.useMockData) {
      return Promise.resolve({ data: { success: true, badgeUnlocked: true } });
    }
    return AuthService.request('post', '/api/accompaniment/validate-competence', {
      young_id: youngId,
      competence_key: competenceKey
    });
  }

  // Récupérer l'auto-évaluation des compétences (skills game)
  async getYoungSkillsAssessment(youngId) {
    if (this.useMockData) {
      return Promise.resolve({
        data: {
          game_name: 'skills',
          young_person_id: youngId,
          data: {
            completion: 0.3,
            skillsAssessment: {
              Strong: { Coaching: {}, Communication: {} },
              WantToLearn: { Diplomatie: {}, Empathie: {} },
              Weak: { Médiation: {}, Curiosité: {} },
              Unknown: { Pragmatisme: {}, Créativité: {}, Négociation: {} }
            }
          }
        }
      });
    }
    return AuthService.request('get', `/observe/young-person/${youngId}/games/skills`);
  }

  // Récupérer la photo de profil d'un jeune
  async getYoungProfilePicture(youngId) {
    if (this.useMockData) {
      return Promise.resolve({ data: null });
    }

    try {
      const response = await AuthService.request(
        'get',
        `/observe/young-person/${youngId}/profile-picture`
      );

      if (response.data.picture_data) {
        const imageUrl = `data:image/png;base64,${response.data.picture_data}`;
        return { data: imageUrl };
      }

      return { data: null };
    } catch (error) {
      console.warn(`Could not fetch profile picture for user ${youngId}:`, error);
      return { data: null };
    }
  }


  // Envoyer une invitation par code (connecter à un jeune)
  async sendInvitationByCode(attachmentCode) {
    if (this.useMockData) {
      // Simuler un délai réseau
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Simuler différentes réponses pour tester
      if (attachmentCode === 'ERROR') {
        throw { response: { status: 404 } };
      }
      if (attachmentCode === 'EXISTS') {
        throw { response: { status: 409 } };
      }

      // Créer un nouveau jeune en attente
      const newPendingYoung = {
        id: Date.now(),
        username: attachmentCode.toLowerCase(),
        firstName: 'En attente',
        lastName: 'de confirmation',
        age: null,
        profilePicture: null,
        relationshipType: 'pending',
        invitationStatus: 'pending',
        dateCreated: new Date().toISOString(),
        lastActivity: null,
        gamesCompletion: 0,
        observationsCount: 0,
        badgesCount: 0,
        otherAccompanists: []
      };

      // Ajouter à la liste mockée
      MOCK_DATA.youngUsers.push(newPendingYoung);

      return Promise.resolve({
        data: {
          success: true,
          message: 'Invitation envoyée avec succès',
          connection_id: Date.now()
        }
      });
    }

    // Appel au backend avec le bon endpoint via AuthService
    return AuthService.request('post', '/connections/connect', {
      attachment_code: attachmentCode,
      connection_notes: null
    });
  }

  // Déconnecter un jeune
  async disconnectYoung(connectionId) {
    if (this.useMockData) {
      // Simuler un délai réseau
      await new Promise(resolve => setTimeout(resolve, 800));

      // Retirer le jeune de la liste mockée
      const index = MOCK_DATA.youngUsers.findIndex(y => y.connectionId === connectionId);
      if (index !== -1) {
        MOCK_DATA.youngUsers.splice(index, 1);
      }

      return Promise.resolve({
        data: {
          success: true,
          message: 'Connexion supprimée avec succès'
        }
      });
    }

    // Appel au backend via AuthService
    return AuthService.request('delete', `/connections/disconnect/${connectionId}`);
  }

  // Récupérer les invitations envoyées en attente
  async getPendingInvitations() {
    if (this.useMockData) {
      return Promise.resolve({ 
        data: { 
          has_pending_requests: false, 
          pending_requests: [] 
        } 
      });
    }

    return AuthService.request('get', '/connection-requests/status/my-requests');
  }

  // === Skill Ratings API ===

  /**
   * Créer ou mettre à jour une évaluation de compétence
   * @param {number} recipientUserId - ID du jeune évalué
   * @param {string} skillName - Nom de la compétence
   * @param {number} rating - Note de 0 à 5
   * @param {string} description - Commentaire optionnel
   */
  async createSkillRating(recipientUserId, skillName, rating, description = null) {
    return AuthService.request('post', '/games/skills/ratings', {
      recipient_user_id: recipientUserId,
      skill_name: skillName,
      rating: rating,
      description: description
    });
  }

  /**
   * Récupérer toutes les évaluations d'un jeune
   * @param {number} recipientId - ID du jeune
   */
  async getSkillRatings(recipientId) {
    return AuthService.request('get', `/games/skills/ratings/${recipientId}`);
  }

  /**
   * Supprimer une évaluation de compétence
   * @param {number} recipientId - ID du jeune
   * @param {string} skillName - Nom de la compétence
   */
  async deleteSkillRating(recipientId, skillName) {
    return AuthService.request('delete', `/games/skills/ratings/${recipientId}/${encodeURIComponent(skillName)}`);
  }

  /**
   * Récupérer la vue combinée (auto-évaluation + évaluations des accompagnants)
   * @param {number} recipientId - ID du jeune
   */
  async getCombinedSkillRatings(recipientId) {
    return AuthService.request('get', `/games/skills/ratings/combined/${recipientId}`);
  }
}

export default new AccompanimentService();
